import React from 'react';
import classNames from 'classnames/bind';

import SwipeMenu from 'app/components/common/SwipeMenu';
import styles from './CenterCategory.module.scss';

const cx = classNames.bind(styles);

const CenterCategory = ({ active }) => (
	<SwipeMenu wide>
		<a
			href="/encar-center/ad"
			className={cx('swipe_contents', { active: active === 'ad' })}
		>
			<span>엔카진단센터</span>
		</a>
		<a
			href="/encar-center/meetgo"
			className={cx('swipe_contents', { active: active === 'meetgo' })}
		>
			<span>엔카믿고센터</span>
		</a>
	</SwipeMenu>
);

export default CenterCategory;
